import React from 'react'
import FormLabel from '@mui/material/FormLabel'
import {
	FormControl,
	FormHelperText,
	RadioGroup,
	RadioGroupProps,
} from '@mui/material'
import {
	Controller,
	type FieldErrors,
	type Control,
} from 'react-hook-form'
import useFormField from '../../hooks/useFormField'

export type RadioControlProps = {
	variant?: 'standard' | 'outlined' | 'filled'
	name: string
	label: string
	errors?: FieldErrors
	control?: Control
	radioGroupProps?: RadioGroupProps
	disabled?: boolean
} & Omit<RadioGroupProps, 'name'>
const RadioControl = ({
	variant = 'standard',
	name,
	label,
	children,
	errors,
	control,
	defaultValue,
	radioGroupProps,
	className,
	sx,
	disabled,
	...rest
}: RadioControlProps) => {
	const { getError } = useFormField()
	const error = getError(name, errors)

	return (
		<FormControl
			variant={variant}
			className={className}
			sx={sx}
			error={!!error}
			disabled={disabled}
		>
			<FormLabel>{label}</FormLabel>
			{control && (
				<Controller
					name={name}
					control={control}
					defaultValue={defaultValue}
					render={({ field }) => (
						<RadioGroup {...radioGroupProps} {...field} row>
							{children}
						</RadioGroup>
					)}
				/>
			)}
			{!control && (
				<RadioGroup
					name={name}
					defaultValue={defaultValue}
					row
					{...rest}
				>
					{children}
				</RadioGroup>
			)}
			{error && <FormHelperText>{error.message}</FormHelperText>}
		</FormControl>
	)
}

export default RadioControl
